// assets
import {
  Setting2,
  Calendar,
  Setting3,
  Activity,
  ChartCircle,
  CpuSetting,
  Trash,
  Story,
  DollarSquare,
  Flash,
  Profile2User,
  DocumentText,
  TaskSquare,
  Diagram,
  Chart
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  config: Setting2,
  roles: Profile2User,
  chartcircle: ChartCircle,
  holiday: Calendar,
  event: Flash,
  appsettings: Setting3,
  adminLogs: Activity,
  decisionLogs: DocumentText,
  instruments: CpuSetting,
  delete: Trash,
  widgets: Story,
  prices: DollarSquare,
  tasks: TaskSquare,
  diagram: Diagram,
  weeklyReports: Chart
};

// ==============================|| MENU ITEMS - CONFIGS ||============================== //
const configs: NavItemType = {
  id: 'configs-group',
  title: '',
  type: 'group',
  children: [
    {
      id: 'configs',
      title: 'Administration',
      type: 'collapse',
      children: [
        {
          id: 'configs',
          title: 'Configs',
          type: 'item',
          url: '/configs',
          breadcrumbs: true,
          icon: icons.config
        },
        {
          id: 'roles',
          title: 'Roles',
          type: 'item',
          url: '/roles',
          breadcrumbs: true,
          icon: icons.roles
        },
        {
          id: 'schedule-strategy',
          title: 'Schedule Strategy',
          type: 'item',
          url: '/trade-schedule',
          breadcrumbs: true,
          icon: icons.tasks
        },
        {
          id: 'market-holidays',
          title: 'Market Holidays',
          type: 'item',
          url: '/market-holidays',
          breadcrumbs: true,
          icon: icons.holiday
        },
        {
          id: 'market-events',
          title: 'Market Events',
          type: 'item',
          url: '/market-events',
          breadcrumbs: true,
          icon: icons.event
        },
        // {
        //   id: 'live-tick-status',
        //   title: 'Live Tick Status',
        //   type: 'item',
        //   url: '/live-tick-status',
        //   breadcrumbs: true,
        //   icon: icons.diagram
        // },
        {
          id: 'subscriptions',
          title: 'Subscriptions',
          type: 'item',
          url: '/subscriptions',
          breadcrumbs: true,
          icon: icons.diagram
        },
        {
          id: 'subscription-plans',
          title: 'Subscription Plans',
          type: 'item',
          url: '/subscription-plans',
          breadcrumbs: true,
          icon: icons.prices
        },
        {
          id: 'tick-store',
          title: 'Tick Store',
          type: 'item',
          url: '/tick-store',
          breadcrumbs: true,
          icon: icons.tasks
        },
        {
          id: 'app-settings',
          title: 'App Settings',
          type: 'item',
          url: '/app-settings',
          breadcrumbs: true,
          icon: icons.appsettings
        },
        {
          id: 'admin-logs',
          title: 'Admin Logs',
          type: 'item',
          url: '/admin-logs',
          breadcrumbs: true,
          icon: icons.adminLogs
        },
        {
          id: 'decision-logs',
          title: 'Decision Logs',
          type: 'item',
          url: '/decision-logs',
          breadcrumbs: true,
          icon: icons.decisionLogs
        },
        {
          id: 'daily-reports',
          title: 'Daily Reports',
          type: 'item',
          url: '/reports/daily',
          breadcrumbs: true,
          icon: icons.weeklyReports
        },
        {
          id: 'weekly-reports',
          title: 'Weekly Reports',
          type: 'item',
          url: '/reports/weekly',
          breadcrumbs: true,
          icon: icons.weeklyReports
        },
        {
          id: 'delete-requests',
          title: 'Delete Requests',
          type: 'item',
          url: '/delete-requests',
          icon: icons.delete
        },
        {
          id: 'daily-tasks',
          title: 'Daily Tasks',
          type: 'item',
          url: '/daily-tasks',
          icon: icons.tasks
        },
        {
          id: 'historic-prices',
          title: 'Stock List',
          type: 'item',
          url: '/historical-prices',
          icon: icons.prices
        },
        {
          id: 'stock-groups',
          title: 'Stock Groups',
          type: 'item',
          url: '/stock-groups',
          icon: icons.widgets
        }
      ]
    }
  ]
};

export default configs;
